import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

// Overriding public url for review apps
export const BASE_URL = import.meta.env.BASE_URL;

export const FULLCALENDAR_LICENSE_KEY = import.meta.env.REACT_APP_FULLCALENDAR_LICENSE_KEY;

export const keycloakConfig: UserManagerSettings = {
  authority: import.meta.env.REACT_APP_KEYCLOAK_URL,
  client_id: import.meta.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  redirect_uri: import.meta.env.REACT_APP_KEYCLOAK_REDIRECT_URI,
  ui_locales: 'el',
  response_type: 'code',
  post_logout_redirect_uri: import.meta.env.REACT_APP_KEYCLOAK_REDIRECT_URI,
  scope: 'openid profile roles',
  // https://authts.github.io/oidc-client-ts/interfaces/UserManagerSettings.html#automaticSilentRenew
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
